module.exports = __webpack_public_path__ + "static/media/procurement-header-bg.2fdcd84e.png";